import React, { FC } from 'react';
import './SocialMediaLink.scss';

export const SOCIAL_MEDIA_FACEBOOK = 'Facebook';
export const SOCIAL_MEDIA_TWITTER = 'Twitter';
export const SOCIAL_MEDIA_INSTAGRAM = 'Instagram';
export const SOCIAL_MEDIA_YOUTUBE = 'YouTube';

const socialMediaChannels = {
    [SOCIAL_MEDIA_FACEBOOK]: 'https://www.facebook.com/BorrowBox-428122074311791',
    [SOCIAL_MEDIA_TWITTER]: 'https://twitter.com/BorrowBox',
    [SOCIAL_MEDIA_INSTAGRAM]: 'https://www.instagram.com/borrowbox',
    [SOCIAL_MEDIA_YOUTUBE]: 'https://www.youtube.com/channel/UC7PyqLA_jFYRNd62gZDH0mQ/videos'
};

type Props = {
    readonly channel:
        | typeof SOCIAL_MEDIA_FACEBOOK
        | typeof SOCIAL_MEDIA_INSTAGRAM
        | typeof SOCIAL_MEDIA_TWITTER
        | typeof SOCIAL_MEDIA_YOUTUBE;
};

export const SocialMediaLink: FC<Props> = ({ channel }) => {
    return (
        <a
            href={socialMediaChannels[channel]}
            rel="noopener noreferrer"
            target="_blank"
            title={`Follow us on ${channel}`}
        >
            <i className={`social-media-link ${channel.toLowerCase()}`} />
        </a>
    );
};
